import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import TestimonialItem from "../../items/TestimonialItem";
import Testimonial1 from "../../../assets/images/testimonial_01.webp";
import Testimonial2 from "../../../assets/images/testimonial_02.webp";
import Testimonial3 from "../../../assets/images/testimonial_03.webp";
import Testimonial4 from "../../../assets/images/testimonial_04.webp";
import Testimonial5 from "../../../assets/images/testimonial_05.webp";
import { useTranslation } from "react-i18next";
const Testimonial = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      image: Testimonial1,
      description: t(
        "“Dancebrite saved us so much time. We sold out our competition and had zero check-in issues.”"
      ),
      name: t("Maya"),
      event: t("Fusion Dance UK"),
    },
    {
      image: Testimonial2,
      description: t(
        "“Game-changer for our team. From judge scoring to promoter tracking, it’s all in one place.”"
      ),
      name: t("James"),
      event: t("Groove Battle Europe"),
    },
    {
      image: Testimonial3,
      description: t(
        "“Game-changer for our team. From judge scoring to promoter tracking, it’s all in one place.”"
      ),
      name: t("James"),
      event: t("Groove Battle Europe"),
    },
    {
      image: Testimonial4,
      description: t(
        "“Dancebrite saved us so much time. We sold out our competition and had zero check-in issues.”"
      ),
      name: t("Maya"),
      event: t("Groove Battle Europe"),
    },
    {
      image: Testimonial5,
      description: t(
        "“Dancebrite saved us so much time. We sold out our competition and had zero check-in issues.”"
      ),
      name: t("Emily Chen"),
      event: t("Groove Battle Europe"),
    },
  ];

  return (
    <section className="relative py-16 xl:py-20 2xl:py-24 bg-magnolia">
      <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto px-6">
        <h2 className="text-deep-purple text-2xl xl:text-3xl 2xl:text-4xl font-bold mb-5 xl:mb-8 2xl:mb-12">
          {t("“What Organisers are saying")}
        </h2>
        <div className="w-full">
          {testimonials?.length > 0 ? (
            <>
              <Swiper
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                pagination={{
                  clickable: true,
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                  1280: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                  },
                }}
                modules={[Autoplay, Pagination]}
              >
                {testimonials.map((item, index) => (
                  <SwiperSlide key={index}>
                    <TestimonialItem data={item} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </>
          ) : (
            <p className="text-center text-2xl text-deep-purple font-bold">
              No testimonials found.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
